
    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StopCauseCategories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StopCauseCategory"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ownerType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopCauses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StopCause"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":205}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/stop-cause.gql\'\\n\\nfragment StopCauseCategories on StopCauseCategory {\\n  _id\\n  id\\n  name\\n  ownerType\\n  stopCauses {\\n    ...StopCause\\n  }\\n  meta {\\n    name\\n    languageCode\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('@/graphql/fragments/stop-cause.gql').definitions));


      module.exports = doc;
    
